<template>
  <PopinBase :is-active="isActive" size="3xs" :z="9999" @close="emit('cancel')">
    <template #body>
      <div class="p-6">
        <p class="font-bold text-xl mb-4">
          {{ $t('components.InputPaper.link') }}
        </p>

        <form @submit.prevent="onSubmit" class="space-y-2">
          <InputBase label="Lien" v-model="formData.href" is-required />
          <InputCheckbox id="open" class="p-4 border border-charcoal-100 rounded" label="Ouvrir dans un nouvel onglet" v-model="formData.isBlank" />

          <div class="flex items-center justify-end !mt-4">
            <ButtonLink size="sm" class="mr-2" @click="emit('cancel')">{{ $t('actions.cancel')}}</ButtonLink>
            <ButtonBase size="sm" color="light" type="submit">{{ $t('actions.submit')}}</ButtonBase>
          </div>
        </form>
      </div>
    </template>
  </PopinBase>
</template>

<script lang="ts" setup>
const props = defineProps({
  isActive: Boolean,
  activeLink: { type: Object, default: null }
})

const emit = defineEmits([ 'cancel', 'input' ])

const { activeLink } = toRefs(props)

const formData = reactive({
  href: '',
  isBlank: false
})

watch(activeLink, (v) => {
  formData.href = v?.href
  formData.isBlank = v?.target == '_blank'
}, { immediate: true })

const onSubmit = () => {
  emit('input', {
    href: formData.href,
    target: formData.isBlank ? '_blank' : '_self'
  })
}</script>